import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.authenticated ||false,
        user: {student_id: null, student_name: null},
        userId: sessionStorage.userId || null,
        userRecord: sessionStorage.userRecord || null,
        studentRecord: sessionStorage.studentRecord || null,
        overlay: false,
        dialog: false,
        loginErrors: '',       
        newPassword: '',
        displayPasswordChanged: false,
        validStudentID: false,
        userInitials: sessionStorage.userInitials || null,
        schoolName: process.env.VUE_APP_THEME_SCHOOL, 
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },

        getUserRecord(state){
            return state.userRecord
        },

        getOverlay(state){
            return state.overlay
        },

        getStudentRecord(state){
            return state.studentRecord
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },       

        getNewPassword(state){
            return state.newPassword
        },

        getDisplayPasswordChanged(state){
            return state.displayPasswordChanged
        },

        getStudentIDValidation(state){
            return state.validStudentID
        },

        getUserInitials(state){
            return state.userInitials
        },

        getSchoolName (state) {
            return state.schoolName
        },

        getUserId (state) {
            return state.userId
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setUserRecord (state, value){
            state.userRecord = value
        },

        setOverlay (state, value){
            state.overlay = value
        },

        setStudentRecord(state, value){
            state.studentRecord = value
        },

        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },        

        setNewPassword(state, value){
            state.newPassword = value
        },

        setDisplayPasswordChanged(state, value){
            state.displayPasswordChanged = value
        },

        setStudentIDValidation(state, value){
            state.validStudentID = value
        },

        setUserInitials(state, value){
            state.userInitials = value
        },

        setUserId (state, value){
            state.userId = value
        }
    },

    actions: {
        async signIn ({ commit, dispatch }, credentials){ 
            commit('setOverlay', true);
                       
            try{
                await axios.get('/sanctum/csrf-cookie')
                console.log("authenticating login credentials");
                const { data } = await axios.post('/api/login-student', credentials);
                console.log('authenticated');
                commit('setUserId', data.id);
                sessionStorage.userId = data.id;
                commit('setUser', credentials);
                commit('setStudentRecord', JSON.stringify(data));
                sessionStorage.studentRecord = JSON.stringify(data);
                dispatch('student');                
                commit('setAuthenticated', true);
                sessionStorage.authenticated = true;
            } catch(error){
                if(error.response){
                    console.log(error.response);
                    commit('setLoginErrors', error.response.data.message);
                }
                else console.log(error)
                commit('setAuthenticated', false);
                commit('setOverlay', false); 
            }

        },

        student({ getters, commit }){ 
            const studentRecord = JSON.parse(getters.getStudentRecord);
            commit('setUserInitials', studentRecord.first_name[0] + studentRecord.last_name[0]);
            sessionStorage.userInitials = studentRecord.first_name[0] + studentRecord.last_name[0];
            commit('setUserRecord', JSON.stringify({name: studentRecord.first_name + ' ' + studentRecord.last_name})); 
            sessionStorage.userRecord = JSON.stringify({name: studentRecord.first_name + ' ' + studentRecord.last_name});                 
        },

        async user({ getters, commit }){
            console.log("getting user information...");
            let url = '/api/user/' + getters.getUserId;           
            await axios.get(url)
                .then(response => {
                    if(response.data.length != 0){
                        commit('setStudentIDValidation', true)
                        commit('setLoginErrors', '');
                        commit('setUserRecord', response.data[0]);                        
                    }
                    else{
                        commit('setLoginErrors', 'Student ID not found');
                        commit('setStudentIDValidation', false)
                        commit('setAuthenticated', false);
                        commit('setOverlay', false);                      
                    }                  
                })
        },        

        async signOut({commit}){                       
            await axios.post('/logout')
            commit('setAuthenticated', false); 
            sessionStorage.clear();
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },

       async getStudents(){
           try{
                return await axios.get('/api/students')
           }
           catch (error) {
                console.log(error);
           }
           
       },       

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       }
    }
}